import React from "react"
import PropTypes from "prop-types"

import { CognitoUserPool } from "amazon-cognito-identity-js"
import {
  APPLICATION_CLIENT_ID,
  USER_POOL,
  COGNITO_COOKIE_PREFIX,
  TOP_DOMAIN,
  USER_EMAIL,
} from "../SessionManagement/constants"

class Logout extends React.Component {
  componentDidMount() {
    const {
      cookies,
      signUserOut,
      history,
      userPool,
      setSplashscreenFinished,
      ssoEnabled,
    } = this.props

    const all = cookies.getAll()

    const UserPoolId = all[USER_POOL]
    const ClientId = all[APPLICATION_CLIENT_ID]

    const cognitoCookies = Object.keys(all).filter((el) =>
      el.startsWith(COGNITO_COOKIE_PREFIX)
    )

    const hostDomainObject = { path: "/" }

    if (UserPoolId && ClientId) {
      cognitoCookies.forEach((el) => {
        cookies.remove(el, hostDomainObject)
      })
      signUserOut({
        userPool:
          userPool ||
          new CognitoUserPool({
            UserPoolId,
            ClientId,
          }),
      })
      if (setSplashscreenFinished) setSplashscreenFinished(false)
    }
    cookies.remove(USER_EMAIL, {
      path: "/",
      domain: TOP_DOMAIN,
    })

    history.push(
      `/${ssoEnabled ? "sso/login" : "login"}${window.location.search}`
    )
  }

  render() {
    return null
  }
}

Logout.propTypes = {
  cookies: PropTypes.shape({
    getAll: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
  }).isRequired,
  signUserOut: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  userPool: PropTypes.shape({}),
  sessionTimer: PropTypes.shape({
    close: PropTypes.func.isRequired,
  }),
  setSplashscreenFinished: PropTypes.func,
  ssoEnabled: PropTypes.bool,
}

Logout.defaultProps = {
  signUserOut: PropTypes.shape({}),
  sessionTimer: null,
  userPool: PropTypes.shape({}),
  setSplashscreenFinished: null,
  ssoEnabled: null,
}

export default Logout
